<script>
    import ShareRedirect from 'views/components/shareRedirect/ShareRedirect.svelte'

    const { params } = $props()
</script>

<ShareRedirect
    {params}
    collection={Backbone.Collection.chapters}
    sourceField="source_chapter_id"
    showPathPrefix="/chapters/show/"
    notFoundMessage={window.i18n.gettext('This chapter could not be found.')}
    selectTitle={window.i18n.gettext('Select a chapter')}
></ShareRedirect>
